import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 mt-24 py-12 px-6 md:px-12 bg-[#050505]">
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-8">
        <div>
          <div className="font-display text-2xl font-black tracking-[0.18em] text-white">VERIFIED</div>
          <p className="text-xs tracking-[0.25em] text-white/40 mt-1 uppercase">Powered by OmniSportsGroup</p>
          <p className="text-sm text-white/50 mt-6 max-w-xs">
            NFL-level athlete intelligence brought to high school sports. Verified measurables. Verified testing. Independent evaluations.
          </p>
        </div>
        <div>
          <div className="label-mono mb-3">Platform</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/about" className="hover:text-electric transition-colors" data-testid="footer-about">About the Founder</Link></li>
            <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
            <li><Link to="/events" className="hover:text-white">Upcoming Events</Link></li>
            <li>Evaluation Engine</li>
            <li>Recruiter Intelligence</li>
          </ul>
        </div>
        <div>
          <div className="label-mono mb-3">For</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li>Athletes</li>
            <li>Parents</li>
            <li>Trainers</li>
            <li>Recruiters</li>
          </ul>
        </div>
        <div>
          <div className="label-mono mb-3">Trust & Legal</div>
          <ul className="space-y-2 text-sm text-white/70 mb-4" data-testid="footer-legal-links">
            <li><Link to="/legal/terms" className="hover:text-electric transition-colors" data-testid="footer-tos">Terms of Service</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-electric transition-colors" data-testid="footer-privacy">Privacy Policy</Link></li>
          </ul>
          <p className="text-xs text-white/40 leading-relaxed">
            Evaluation reports represent independent scouting opinions and do not guarantee recruitment outcomes or scholarship offers.
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-white/5 text-xs text-white/30 flex flex-col gap-3">
        <p className="text-white/40 max-w-3xl leading-relaxed">
          All intellectual property created for OmniAgency is owned exclusively by OmniSportsGroup, LLC.
        </p>
        <div className="flex flex-col md:flex-row gap-2 justify-between">
          <div>© {new Date().getFullYear()} OmniSportsGroup, LLC. All Rights Reserved.</div>
          <div>Nashville, TN</div>
        </div>
      </div>
    </footer>
  );
}
